export default __webpack_public_path__ + "static/media/dataEntry.30d97532.jpg";